import React, { useEffect } from "react";

/**
 * Lightweight, additive — not a redesign of your gameover screen.
 * Drop <ScoreboardPanel gameKey="crashlanes" score={score} isNewRecord={isNewRecord}
 *   leaderboard={leaderboard} fetchLeaderboard={fetchLeaderboard} /> anywhere
 * inside your existing gameover JSX block. Restyle freely — this is
 * intentionally plain so it doesn't clash with your existing art direction.
 */
export default function ScoreboardPanel({ score, isNewRecord, leaderboard = [], fetchLeaderboard }) {
  useEffect(() => {
    fetchLeaderboard?.();
  }, [fetchLeaderboard]);

  return (
    <div className="w-full max-w-xs mx-auto mt-3 rounded-2xl bg-black/30 p-3 text-white">
      {isNewRecord && (
        <div className="text-center text-xs font-bold text-yellow-300 mb-2">🏆 New personal best!</div>
      )}
      <div className="text-[10px] uppercase tracking-wider text-white/60 text-center mb-1">Top 10</div>
      <ol className="space-y-1 text-xs">
        {leaderboard.map((row) => (
          <li key={row.rank} className="flex justify-between">
            <span>{row.rank}. {row.name || "Anonymous"}</span>
            <span className="tabular-nums">{row.score}</span>
          </li>
        ))}
        {leaderboard.length === 0 && (
          <li className="text-white/40 text-center">No scores yet — be the first!</li>
        )}
      </ol>
    </div>
  );
}
